import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetDailyPlayerReturnLossResponseData } from '@/modules/promotion/type'
import DailyPlayerReturnLossTable from '../DailyPlayerReturnLossTable'

interface DailyPlayerReturnLossListingProps {
	data: GetDailyPlayerReturnLossResponseData[]
	total: number
	isLoading?: boolean
}

export default function DailyPlayerReturnLossListing({
	data,
	total,
	isLoading,
}: DailyPlayerReturnLossListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title="ยอดเสียรายวันของผู้เล่น"
					description="แสดงยอดเสียรายวันของผู้เล่นแต่ละคนในแต่ละประเภทเกม"
				/>
			</div>
			<Separator />
			<DailyPlayerReturnLossTable
				data={data}
				total={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
